<template lang="html">
  <div id="product-detail-page" data-aos="fade">
    <section class="container main-section">
      <div class="row">
        <div class="col-12 col-info">
          <h2 class="mb-3 title-s1">Poliestireno alto impacto Productos Estándar</h2>
        </div>

        <div class="col-lg-5 col-gallery">
          <div class="box-gallery">
            <img src="public/images/pages/products/product-1-xl.jpg">
          </div>
        </div>

        <div class="col-lg-7 col-info">
          <!-- <h2 class="mb-3 title-s1">Tira de exhibidora de impulso</h2> -->

          <div class="box-table">
            <h5 class="table-title">Placa Estandar Color Blanco</h5>

            <div class="table-responsive-lg">
              <table class="table table-sm">
                <thead>
                  <tr>
                    <th class="">Calibre (pulg)</th>
                    <th class="">Medida (cm)</th>
                    <th class="">Peso/Pza</th>
                    <th class="">Pzas/Paq</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td class="bg-1">0.015</td>
                    <td class="bg-2">120 x 152</td>
                    <td class="bg-1">0.750</td>
                    <td class="bg-2">40</td>
                  </tr>
                  <tr>
                    <td class="bg-1">0.020</td>
                    <td class="bg-2">120 x 152</td>
                    <td class="bg-1">1.000</td>
                    <td class="bg-2">30</td>
                  </tr>
                  <tr>
                    <td class="bg-1">0.030</td>
                    <td class="bg-2">120 x 152</td>
                    <td class="bg-1">1.500</td>
                    <td class="bg-2">20</td>
                  </tr>
                  <tr>
                    <td class="bg-1">0.040</td>
                    <td class="bg-2">120 x 152</td>
                    <td class="bg-1">2.000</td>
                    <td class="bg-2">15</td>
                  </tr>
                  <tr>
                    <td class="bg-1">0.060</td>
                    <td class="bg-2">120 x 152</td>
                    <td class="bg-1">3.000</td>
                    <td class="bg-2">10</td>
                  </tr>
                  <tr>
                    <td class="bg-1">0.100</td>
                    <td class="bg-2">120 x 152</td>
                    <td class="bg-1">5.000</td>
                    <td class="bg-2">8</td>
                  </tr>
                </tbody>
              </table>

              <p class="p-md mt-3 text-justify">Estos productos son adecuados para su utilizacion en procesos de impresión, serigrafía, termoformado, rauteado,punto de venta y otros procesos similares.</p>
            </div>
          </div>

          <div class="mt-4 box-table">
            <h5 class="table-title">Rollos y Bobinas</h5>

            <div class="table-responsive-lg">
              <table class="table table-sm">
                <thead>
                  <tr>
                    <th class="">Calibre (pulg)</th>
                    <th class="">Ancho (cm)</th>
                    <th class="">Peso/Prom</th>
                    <th class="">Mts/Rolo (aprox)</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td class="bg-1">0.015</td>
                    <td class="bg-2">56</td>
                    <td class="bg-1">45 KG</td>
                    <td class="bg-2">195 mts</td>
                  </tr>
                  <tr>
                    <td class="bg-1">0.020</td>
                    <td class="bg-2">56</td>
                    <td class="bg-1">45 KG</td>
                    <td class="bg-2">145 mts</td>
                  </tr>
                  <tr>
                    <td class="bg-1">0.015</td>
                    <td class="bg-2">120</td>
                    <td class="bg-1">60 KG</td>
                    <td class="bg-2">120 mts</td>
                  </tr>
                  <tr>
                    <td class="bg-1">0.020</td>
                    <td class="bg-2">120</td>
                    <td class="bg-1">60 KG</td>
                    <td class="bg-2">90 mts</td>
                  </tr>
                </tbody>
              </table>

              <p class="p-md mt-3 text-justify">Estos productos son adecuados para su utilizacion en procesos de impresión, serigrafia, termoformado, pantallas, micas y otros procesos similares.</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
}
</script>
